export default {"src":"/_next/static/media/stressMotivation.96eaad4c.svg","height":621,"width":1044,"blurWidth":0,"blurHeight":0};